import { createContext, useContext, useState } from "react";
import config from "../config";
import { useOktaAuth } from "@okta/okta-react";

interface EnrollmentPortalStatusContextType {
  verifyUserEmail: (email: string, setError: (message: string) => void) => Promise<string | null>;
  portalUrl: string | null;
}

const EnrollmentPortalStatusContext = createContext<EnrollmentPortalStatusContextType | undefined>(undefined);

export const EnrollmentPortalStatusProvider = ({ children }: { children: React.ReactNode }) => {
    const { authState } = useOktaAuth(); 
    const oktaAccessToken = authState?.accessToken?.accessToken; 

    const [portalUrl, setPortalUrl] = useState<string | null>(null);
    const ENROLLMENTPORTAL_USER_CREATION_STATUS = config.api.endpoints.ENROLLMENTPORTAL_USER_CREATION_STATUS;
    
    
    const verifyUserEmail = async (email: string, setError: (message: string) => void) => {
        if (!oktaAccessToken) {
            console.warn(" No Okta token available. No API call.");
            return null;
        }
        const APIURL_1 = `${ENROLLMENTPORTAL_USER_CREATION_STATUS}?email=${email}`;
        try {
            const response = await fetch(`${ENROLLMENTPORTAL_USER_CREATION_STATUS}?email=${email}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${oktaAccessToken}`,
                    "Content-Type": "application/json",
                },
            });
            if (!response.ok) {
                throw new Error(`API Error: ${response.statusText}`);
            }
            const data = await response.json(); 
            // Case - user does not exist
            if (data.totalSize === 0 || !data.records.length) {
                setError("Please provide a valid e-mail address that was used when enrolling.");
                return null;
            }

            // Case - if valid email & Created_From_New_Portal__c from API
            const userRecord = data.records[0];
            if (userRecord.Created_From_New_Portal__c === true) {
                window.location.href = config.LINKS.ENROLLMENT_PORTAL;
                return null;
            }else if (userRecord.Created_From_New_Portal__c === false) {
                window.location.href = config.LINKS.APPLYNOW_PORTAL;
                return null;
            }

            console.log("API Response:", data, userRecord);

            return data;

        } catch (error) {
            console.error("Error verifying email:", error);
            setError("An error occurred while verifying the email, Please try again.");
            return null;
        }
    };

  return (
    <EnrollmentPortalStatusContext.Provider value={{ verifyUserEmail, portalUrl }}>
      {children}
    </EnrollmentPortalStatusContext.Provider>
  );
};

export const useEnrollmentPortalStatus = () => {
  const context = useContext(EnrollmentPortalStatusContext);
  if (!context) {
    throw new Error("useEnrollmentPortalStatus must be used within an EnrollmentPortalStatusProvider");
  }
  return context;
};
